import React, { useState } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Box, Button, Typography, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import api from 'common/api'
import useScid from 'common/use-scid'

import useCanManageApplications from '../../../useCanManageApplications'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import PreviewApplicationButton from 'routes/application/Activate/components/PreviewApplicationButton'

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: theme.spacing(68),
  },
  noButton: {
    marginLeft: theme.spacing(2),
  },
}))

export const ConfirmConfigurationStep = ({ appConfig, completeStep, history }) => {
  const submissionVerified = appConfig && appConfig.verification && appConfig.verification.submissionVerified
  const firstYearsEnabled = appConfig && appConfig.firstYearConfiguration && appConfig.firstYearConfiguration.enabled
  const transfersEnabled = appConfig && appConfig.transferConfiguration && appConfig.transferConfiguration.enabled
  const firstOrTransfersEnabled = firstYearsEnabled || transfersEnabled
  const [confriming, setConfirming] = useState(false)
  const [confirmationError, setConfirmationError] = useState(false)
  const styles = useStyles()
  const canCompleteStep = useCanManageApplications()
  const scid = useScid()

  const confirmConfiguration = () => {
    setConfirming(true)
    api
      .put(
        `/api/colleges/${scid}/integrations/application/configuration/${appConfig.id}/verification/confirmConfiguration`,
      )
      .then(async () => {
        setConfirmationError(false)
        completeStep()
      })
      .catch(() => {
        setConfirming(false)
        setConfirmationError(true)
      })
  }

  return (
    <Box
      px={4}
      py={1}
    >
      <Typography>{'Have you finished setting up your application in Scoir?'}</Typography>
      <Box
        mt={1}
        mb={3}
      >
        <Typography variant="caption">
          {`By clicking "Yes" you are verifying your application selections for this cycle. After August 1st, some aspects of your configuration can't be updated once your application is activated.`}
        </Typography>
      </Box>
      <Button
        color="primary"
        variant="contained"
        disabled={!submissionVerified || !canCompleteStep || confriming || !firstOrTransfersEnabled}
        onClick={confirmConfiguration}
      >
        Yes
      </Button>
      <Button
        color="primary"
        variant="outlined"
        className={styles.noButton}
        disabled={!canCompleteStep || confriming}
        onClick={() => history.push(`${import.meta.env.BASE_URL}/application/settings`)}
      >
        No, Go to Application Configuration&nbsp;
        <FontAwesomeIcon icon={faArrowRight} />
      </Button>
      <PreviewApplicationButton configurationId={appConfig?.id} />
      {!firstOrTransfersEnabled && (
        <Box mt={2}>
          <Typography
            variant="caption"
            color="error"
          >
            To activate, you must enable at least one applicant type. Please return to your Application Configuration
            and indicate your intent to accept first-year, transfer, or both types of application.
          </Typography>
        </Box>
      )}
      {confirmationError && (
        <Box mt={2}>
          <Typography
            variant="caption"
            color="error"
          >
            An error occurred while confirming your configuration.
            <Link
              href="https://www.scoir.com/support"
              target="_blank"
              rel="noreferrer"
            >
              Please contact customer support.
            </Link>
          </Typography>
        </Box>
      )}
    </Box>
  )
}

ConfirmConfigurationStep.propTypes = {
  appConfig: PropTypes.object,
  completeStep: PropTypes.func,
  history: PropTypes.any,
}

export default withRouter(ConfirmConfigurationStep)
